import { defineComponent, PropType } from 'vue';
import { product_search_product } from '../../../../objects/v1_3/product/search/product_search_product';
import { Web_Engine } from '../../../../services/web_engine';



const Web_Engines = new Web_Engine();

export default defineComponent({
    name: "strict_fitlers",
    components: {
    },
    emits: [
        "onStrictFilterChange"
    ],
    props: {
        remove_filter: String,
        tours: Array as PropType<product_search_product[]>
        
    },
    data() {
        return {
            BrandFilter: [] as string[],
            DurationFilter: [] as string[],
            DepartureFilter: [] as string[],
            selectedBrand: '',
            selectedDeparture: '', 
            selectedDuration: '',
            selectedSort: '',
        }

    },
    methods: {

        populateFilters() {
            // Clear filters to prevent duplicates on refresh
            this.BrandFilter = [];
            this.DurationFilter = [];
            this.DepartureFilter = [];

            if (this.tours && Array.isArray(this.tours)) {
                this.tours.forEach((tour) => {
                    if (tour.brand && !this.BrandFilter.includes(tour.brand.toLowerCase())) {
                        this.BrandFilter.push(tour.brand.toLowerCase());
                    }
                    // Categorize tours into "Day Tours" (0 days, has hours) and "2-8 Day Tours" (2-8 days)
                    if (tour.duration) {
                        if (tour.duration.days === 0 && tour.duration.hours > 0) {
                            if (!this.DurationFilter.includes('Day Tours')) {
                                this.DurationFilter.push('Day Tours');
                            }
                        } else if (tour.duration.days >= 2 && tour.duration.days <= 8) {
                            if (!this.DurationFilter.includes('2-8 Day Tours')) {
                                this.DurationFilter.push('2-8 Day Tours');
                            }
                        }
                    }
                    if (tour.start_location.city && !this.DepartureFilter.includes(tour.start_location.city.toLowerCase())) {
                        this.DepartureFilter.push(tour.start_location.city.toLowerCase());
                    }
                    if (tour.start_location.title && !this.DepartureFilter.includes(tour.start_location.title.toLowerCase())) {
                        this.DepartureFilter.push(tour.start_location.title.toLowerCase());
                    }
                });

                ['edinburgh', 'inverness', 'glasgow'].forEach(city => {
                    const matches = this.DepartureFilter.filter(dep => dep.includes(city));
                    if (matches.length > 0) {
                        // Remove all matches
                        this.DepartureFilter = this.DepartureFilter.filter(dep => !dep.includes(city));
                        // Add just the city name
                        this.DepartureFilter.push(city);
                    }
                });

                // Capitalise final output
                this.DepartureFilter = this.DepartureFilter.map(dep => dep.charAt(0).toUpperCase() + dep.slice(1));

                // Replace 'hex' with 'Highland Explorer Tours' and 'hag' with 'Haggis Adventures'
                this.BrandFilter = this.BrandFilter.map(brand => {
                    if (brand.includes('hex')) return 'Highland Explorer Tours';
                    if (brand.includes('hag')) return 'Haggis Adventures';
                    return brand;
                });


                if(!window.location.hostname.includes('localhost'))
                {
                    // Select default brand if configured and present
                    const defaultBrand = import.meta.env.VITE_DEFAULT_BRAND_FILTER || null;
                    if (defaultBrand && this.BrandFilter.includes(defaultBrand)) 
                    {
                        this.selectedBrand = defaultBrand;
                        this.StrictFilterChange();
                    }
                }
                
            }
        },
        clearFilters() {
            this.selectedBrand = '';
            this.selectedDeparture = '';
            this.selectedDuration = '';
            this.StrictFilterChange();
        },
        showClearFiltersButton() {
            if(this.selectedBrand || this.selectedDeparture || this.selectedDuration)
            {
                return true;
            }
            return false;
        },
        StrictFilterChange() {
            const filters = {
                brand: this.selectedBrand,
                departure: this.selectedDeparture,
                duration: this.selectedDuration,
                sort: this.selectedSort
            };
            this.$emit('onStrictFilterChange', filters);
        }

    },
    watch: {
        tours: {
            handler() {
                this.populateFilters();
            },
            immediate: true,
            deep: true
        }
    }
})